import React from "react";
import {
  DefaultRouteParam,
  RouteConfig,
} from "../../../config/router/router.config";

export type MaintainerRouteParam = DefaultRouteParam;

export const maintainerRoute: RouteConfig = {
  name: "Maintainer",
  Component: React.lazy(() => import("./Maintainer.view")),
  path: `/user/maintainer`,
  isPrivate: true,
  roleLevelExact: 0,

  options: {
    label: "Maintainer",
    testID: "MenuUserMaintainer",
  },
};
